import { last } from 'ramda';

import { TNextStep, TStep, TFormStoreData, EStepCode } from '../../../types/form';
import { getNextStep } from './getNextStep';
import { TAnswersState } from '../types/internal';
import { IConditionSchema } from '../../../repositories/lead-realtor-form/entities/schema/ConditionSchema';

interface IGetFirstStepParams {
  formData: TFormStoreData;
  stepsToSkip: EStepCode[];
  answersState: TAnswersState;
}

/**
 * Хелпер для установки 1го шага формы.
 * Вообще, в схеме первый шаг устанавливается через поле schema.firstStepCode.
 * Но если мы захотим его скипнуть (через skipSteps), то нужно запустить механизм для пропуска скрытых шагов
 * Используется тот же алгоритм, что и при переходе на следующий шаг,
 * за исключение того что текущий шаг находится "перед" первым
 */
export const getFirstStepCode = (params: IGetFirstStepParams) => {
  /** Это - гипотететический -1й шаг - находится перед "firstStepCode" (перед точкой входа в схему) */
  const currentStep = {
    nextStep: [
      {
        conditions: [] as IConditionSchema[],
        nextStepCode: params.formData.schema.firstStepCode,
      },
    ],
  } as TStep;

  /** От этого -1го шага мы шагаем вперед, используя поиск следующего шага */
  const steps = getNextStep({
    answersState: params.answersState,
    formData: params.formData,
    currentStep,
    stepsToSkip: params.stepsToSkip,
  });

  const firstStep = last(steps) as TNextStep;

  return firstStep.nextStepCode;
};
